import { connect } from 'react-redux'
import Users from 'modules/Users/index'
import {
  getUserMetrics,
  getUserList,
  createUser,
  updateUser,
  getSingleUser,
  updateUserStatus,
  deleteUser,
  setSingleUser,
} from 'modules/Users/actions'
import {  getNotificationCatalogues,
  sendNotificationEmail
} from 'modules/Students/actions'
import selectors from 'modules/Users/selectors'
import instSelector from 'modules/Students/selectors'
import { getUserRoles, getListOfCountries } from 'modules/Auth/actions'
import authSelector from 'modules/Auth/selectors'

const mapStateToProps = state => ({
  userMetrics: selectors?.getUserMetricsData(state),
  userList: selectors?.getUserListData(state),
  userRole: authSelector?.getUserRoleList(state),
  singleUserData: selectors?.getSingleUserData(state),
  listOfCountries: authSelector.getListOfCountries(state),
  permissions: authSelector.getUserPermissions(state),
  notificationCatalogues : instSelector.getNotificationCatalogueData(state)
})

const mapDispatchToProps = {
  getUserMetrics,
  getUserList,
  getUserRoles,
  createUser,
  updateUser,
  getSingleUser,
  updateUserStatus,
  deleteUser,
  setSingleUser,
  getListOfCountries,
  getNotificationCatalogues,
  sendNotificationEmail
}

export default connect(mapStateToProps, mapDispatchToProps)(Users)
